import React, { FC } from 'react';
import styles from './ContentWrapper.module.css';

const ContentWrapper: FC<{}> = (props) => {
  return <div className={styles.contentwrapper}>{props.children}</div>;
};

export default ContentWrapper;
